<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781429988070_toc01#toctitle1" id="title1"><span><strong class="b">Part One</strong></span></a></div>
<div class="verse"><span>It has sometimes taken me ten years to understand even a little of some important event that happened to me. Oh, I could have given a perfectly factual account of what happened but I didn’t know what it meant until I knew the consequences.</span></div>
<div class="source"><span>—KATHERINE ANNE PORTER</span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429988070_p01.vue?6ae05a3a